<style scoped>
.required {
  color: #b71c1c !important;
}
</style>

<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :max-width="maxWidth"
    :min-width="minWidth"
  >
    <template v-slot:activator="{ on }">
      <anchor-text-field
        v-model="displayDate"
        :id="id"
        :class="inputClass"
        :clearable="clearable"
        :label="label"
        :dense="dense"
        :disabled="disabled"
        :prepend-icon="prependIcon"
        :append-icon="appendIcon"
        :outlined="outlined"
        :hide-details="hideDetails"
        :rules="rules"
        @blur="onTextInputBlur"
        v-on="on"
      >
        <template v-slot:label>
          {{ label }} <span class="required" v-if="required"> *</span>
        </template>
      </anchor-text-field>
    </template>
    <v-date-picker
      v-model="isoDate"
      @input="menu = false"
      :min="strFromDate(clearedMinDate)"
      :max="strFromDate(clearedMaxDate)"
    />
  </v-menu>
</template>

<script>
import requiredMixin from '../../../mixins/utils/form/requiredMixin';

/* eslint no-restricted-properties: ["off", { "object": "window", "property": "isNaN" }] */
export default {
  name: 'AnchorDatePickerInput',
  mixins: [requiredMixin],
  props: {
    id: String,
    clearable: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [String, Boolean],
      default: 'auto',
    },
    inputClass: {
      type: String,
      default: 'mb-2',
    },
    label: {
      type: String,
      default: 'Pick a date',
    },
    light: {
      type: Boolean,
      default: false,
    },
    maxDate: Date,
    maxWidth: {
      type: [Number, String],
      default: '290px',
    },
    minDate: Date,
    minWidth: {
      type: [Number, String],
      default: '290px',
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    prependIcon: {
      type: String,
      default: 'mdi-calendar',
    },
    appendIcon: String,
    rules: Array,
    value: Date,
  },
  data: () => ({
    displayDate: null,
    isoDate: '',
    menu: false,
  }),
  computed: {
    clearedMinDate() {
      return this.resetHourInfo(this.minDate);
    },
    clearedMaxDate() {
      return this.resetHourInfo(this.maxDate);
    },
  },
  methods: {
    resetHourInfo(date) {
      if (!date) { return null; }

      const noTimeDate = new Date(date);
      noTimeDate.setUTCHours(0, 0, 0, 0);
      return noTimeDate;
    },
    strFromDate(dateObj) {
      if (!dateObj) { return ''; }
      return dateObj.toISOString().substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    onTextInputBlur() {
      const date = this.resetHourInfo(new Date(this.displayDate));
      if (date instanceof Date && !window.isNaN(date)) {
        const greaterThanMaxDate = this.clearedMaxDate && this.clearedMaxDate < date;
        const lessThanMinDate = this.clearedMinDate && this.clearedMinDate > date;
        if (lessThanMinDate || greaterThanMaxDate) {
          this.displayDate = this.formatDate(this.isoDate);
        } else {
          this.isoDate = this.parseDate(this.displayDate);
        }
      } else {
        this.displayDate = this.formatDate(this.isoDate);
      }
    },
  },
  watch: {
    isoDate(val) {
      const displayDate = this.formatDate(val);
      this.displayDate = displayDate;
      this.$emit('input', val ? new Date(displayDate) : null);
    },
    value(val) {
      this.isoDate = this.strFromDate(val);
    },
  },
  mounted() {
    if (this.value) {
      this.isoDate = this.strFromDate(this.value);
    }
  },
};
</script>
